import { useEffect, useRef, useState } from 'react';

export type WorkerActionData = {
    key: string;
    time: number;
    callbackFunc: () => void;
};
export const useSecWorker = () => {
    const [count, setCount] = useState<number>(0);
    const worker = useRef<Worker>();
    const actionList = useRef<Array<WorkerActionData>>([]);

    const registWorkerAction = (item: WorkerActionData) => {
        console.log(`regist worker action`, item.key);
        actionList.current.push({
            key: item.key,
            time: item.time + count,
            callbackFunc: item.callbackFunc,
        });
    };
    const unregistWorkerAction = (key: string) => {
        console.log(`unregist worker action`, key);
        if (key !== '') {
            let newList: Array<WorkerActionData> = [];
            actionList.current.forEach(item => {
                if (item.key !== key) {
                    newList.push(item);
                }
            });
            actionList.current = newList;
        }
    };
    const forceRunWorkerAction = (key: string) => {
        console.log(`force run worker action`, key);
        if (key !== '') {
            let newList: Array<WorkerActionData> = [];
            actionList.current.forEach(item => {
                if (item.key === key) {
                    item.callbackFunc();
                } else {
                    newList.push(item);
                }
            });
            actionList.current = newList;
        }
    };
    useEffect(() => {
        worker.current = new Worker(
            new URL('./workers/sec_worker.ts', import.meta.url)
        );
        worker.current.onmessage = function (ev: MessageEvent<string>) {
            if (ev.data === 'sec_worker') {
                setCount(v => v + 1);
                // console.log('Message received from myWorker: ', ev.data);
            }
        };
        return () => {
            console.log('Terminate web worker');
            if (worker.current) worker.current.terminate();
        };
    }, []);
    useEffect(() => {
        let notDone: Array<WorkerActionData> = [];
        actionList.current.forEach(item => {
            if (item.time < count) {
                console.log(`run worker action`, item.key);
                item.callbackFunc();
            } else {
                notDone.push(item);
            }
        });
        actionList.current = notDone;
    }, [count]);

    return { registWorkerAction, unregistWorkerAction, forceRunWorkerAction };
};

export type useSecWorkerState = ReturnType<typeof useSecWorker>;
